import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=8e20df6e"
var script = {}
import style0 from "./FullPage.vue?vue&type=style&index=0&id=8e20df6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports